import React, { Component } from 'react';
import * as $ from 'jquery';
import Footer from '../Footer.js';
import Navbar from '../Navbar.js';
import QuestionsForm from './QuestionsForm.js';
import ReferralForm from './ReferralForm.js';
import SuccessDialog from './SuccessDialog.js';
import UserForm from './UserForm.js';
import axios from 'axios';
import brandLogo from '../../images/brand-logo-dark.png';
import { ERRORS } from '../../App.js';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';

export const QUESTION_TYPE = {
  OPTIONS: 1,
  COMMENTS: 2
};

const SECTION = {
  USER: 1,
  QUESTIONS: 2,
  REFER: 3
};

let cancelToken;

class SurveyContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    $(window).off("resize", this.resize);
  }

  componentDidMount() {
    $(window).resize(this.resize);
    this.resize();
    this.setModalListener();
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  didGetCenters = (response) => {
    this.setState({ centers: response });
  }

  didGetCities = (response) => {
    this.setState({ cities: response });
  }

  didGetSurvey = (response) => {
    this.setState({
      section: SECTION.QUESTIONS,
      survey: response
    }, this.scrollTop);
  }

  didSendReferral = () => {
    $('#btnSuccess').click();
  }

  didSendSurvey = () => {
    this.setState({ section: SECTION.REFER }, this.scrollTop);
  }

  getAnswers = () => {
    const answers = [];

    this.state.survey.sections.forEach((section) =>
      section.questions.forEach((question) => {
        answers.push({
          id: question.id,
          value: $("input[name='" + question.id + "']:checked").val(),
          comments: $("textarea#" + question.id).val()
        });
      })
    );

    return answers;
  }

  getCenters = (params) => {
    this.props.post(
      "/getCentersByCity",
      params,
      (response) => this.didGetCenters(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getCities = (params) => {
    this.props.post(
      "/getCities",
      params,
      (response) => this.didGetCities(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getInitState = () => {
    return({
      center: null,
      centers: [],
      cities: [],
      company: "",
      email: "",
      name: this.props.user ? this.props.user.name + " " + this.props.user.lastname : "",
      noReferral: true,
      phone: "",
      referralComments: "",
      referralCompany: "",
      referralEmail: "",
      referralName: "",
      referralPhone: "",
      section: SECTION.USER,
      suite: "",
      survey: null,
      toDashboard: false
    });
  }

  getSurvey = (params) => {
    this.props.post(
      "/getSurvey",
      params,
      (response) => this.didGetSurvey(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleCenterClick = (center) => {
    this.setState({ center: center });
  }

  handleCityClick = (city) => {
    this.setState({
      city: city,
      center: null
    });
    this.setState(
      { centers: [] },
      () => this.getCenters({
        city_id: city.id,
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      })
    );
  }

  handleCompanyChange = (event) => {
    this.setState({ company: event.target.value });
  }

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  }

  handleNameChange = (event) => {
    this.setState({ name: event.target.value });
  }

  handleNoReferral = () => {
    this.setState({ noReferral: !this.state.noReferral });
  }

  handlePhoneChange = (event) => {
    this.setState({ phone: event.target.value });
  }

  handleQuestionsForm = (event) => {
    event.preventDefault();
    this.sendSurvey({
      id: this.state.survey.id,
      questions: this.getAnswers(),
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  handleReferralComments = (event) => {
    this.setState({ referralComments: event.target.value });
  }

  handleReferralCompany = (event) => {
    this.setState({ referralCompany: event.target.value });
  }

  handleReferralEmail = (event) => {
    this.setState({ referralEmail: event.target.value });
  }

  handleReferralForm = (event) => {
    event.preventDefault();

    if (this.state.noReferral) {
      this.didSendReferral();
    } else {
      this.sendReferral({
        id: this.state.survey.id,
        comments: this.state.referralComments,
        company: this.state.referralCompany,
        email: this.state.referralEmail,
        name: this.state.referralName,
        phone: this.state.referralPhone,
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      });
    }
  }

  handleReferralName = (event) => {
    this.setState({ referralName: event.target.value });
  }

  handleReferralPhone = (event) => {
    this.setState({ referralPhone: event.target.value });
  }

  handleSuiteChange = (event) => {
    this.setState({ suite: event.target.value });
  }

  handleUserForm = (event) => {
    event.preventDefault();
    this.getSurvey({
      center_id: this.state.center.id,
      company: this.state.company,
      email: this.state.email,
      name: this.state.name,
      phone: this.state.phone,
      suite: this.state.suite,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  reload = () => {
    this.getCities({
        token_id: this.props.getTokenId()
      });
  }

  resize = () => {
    $('#content').css({
      paddingTop: this.props.getNavbarHeight()
    });
  }

  scrollTop = () => {
    $('#content')[0].scrollIntoView();
  }

  sendReferral = (params) => {
    this.props.post(
      "/sendReferral",
      params,
      (response) => this.didSendReferral(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  sendSurvey = (params) => {
    this.props.post(
      "/sendSurvey",
      params,
      (response) => this.didSendSurvey(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  setModalListener = () => {
    $('#modalSuccess').on('hidden.bs.modal', () => {
      this.setState({ toDashboard: true });
    });
  }

  renderFooter = () => {
    return(
      <Footer />
    );
  }

  renderNavbar = () => {
    return(
      <Navbar
        handleLanguageChange={this.props.handleLanguageChange}
        lang={this.props.lang} />
    );
  }

  renderSection = () => {
    switch (this.state.section) {
      default:
      case SECTION.USER:
        return this.renderUserForm();
      case SECTION.QUESTIONS:
        return this.renderQuestionsForm();
      case SECTION.REFER:
        return this.renderReferralForm();
    }
  }

  renderSuccessDialog = () => {
    return(
      <SuccessDialog />
    );
  }

  renderQuestionsForm = () => {
    return(
      <QuestionsForm
        handleQuestionsForm={this.handleQuestionsForm}
        survey={this.state.survey} />
    );
  }

  renderReferralForm = () => {
    return(
      <ReferralForm
        handleNoReferral={this.handleNoReferral}
        handleReferralComments={this.handleReferralComments}
        handleReferralCompany={this.handleReferralCompany}
        handleReferralEmail={this.handleReferralEmail}
        handleReferralForm={this.handleReferralForm}
        handleReferralName={this.handleReferralName}
        handleReferralPhone={this.handleReferralPhone}
        referralComments={this.state.referralComments}
        noReferral={this.state.noReferral}
        referralCompany={this.state.referralCompany}
        referralEmail={this.state.referralEmail}
        referralName={this.state.referralName}
        referralPhone={this.state.referralPhone} />
    );
  }

  renderUserForm = () => {
    return(
      <UserForm
        center={this.state.center}
        centers={this.state.centers}
        city={this.state.city}
        cities={this.state.cities}
        company={this.state.company}
        email={this.state.email}
        handleCenterClick={this.handleCenterClick}
        handleCityClick={this.handleCityClick}
        handleCompanyChange={this.handleCompanyChange}
        handleEmailChange={this.handleEmailChange}
        handleNameChange={this.handleNameChange}
        handlePhoneChange={this.handlePhoneChange}
        handleSuiteChange={this.handleSuiteChange}
        handleUserForm={this.handleUserForm}
        name={this.state.name}
        phone={this.state.phone}
        suite={this.state.suite} />
    );
  }

  render() {
    if (this.state.toDashboard) {
      return <Redirect to="/events" />;
    }

    return(
      <div>
        {this.renderNavbar()}
        <div className="container-fluid" id="content">
          <div className="text-center">
            <img alt="IOS OFFICES" height="200px" src={brandLogo} />
          </div>
          {this.renderSection()}
          {this.renderSuccessDialog()}
        </div>
        {this.renderFooter()}
      </div>
    );
  }
}

export default translate('common')(SurveyContainer);



// WEBPACK FOOTER //
// ./src/guest/survey/SurveyContainer.js